import { createSelector } from 'reselect';
import {
  TApiKeyRequestKey,
  TApiRequestState,
  TApplicationRequestKey,
  TApplicationsManagementState,
  TApplicationState
} from '../libs/store';
import { useSelector } from 'react-redux';

/*
 * apiKeysManagement:
 */

const applicationsManagementState = (state: TApplicationState) => state?.applicationsManagement;

export const isLoadingApplicationSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.isLoading
);

export const errorApplicationSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.error
);

export const isLoadingApplicationApiKeysSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.isLoadingApiKeys
);

export const applicationApiKeysListSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.application?.apiKeys || []
);

export const applicationSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.application
);

export const isLoadedApplicationSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.isLoaded
);
export const isLoadingApplicationsListSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.applications.isLoading
);

export const errorApplicationsSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.applications.error
);
export const applicationsListSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.applications.list
);

export const applicationsMaxCountSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.applications.maxCountOfApps
);

export const isLoadedApplicationsListSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.applications.isLoaded
);

export const apiKeysRequestsSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.apiKeysRequests
);

export const applicationRequestsSelector = createSelector(
  applicationsManagementState,
  (state: TApplicationsManagementState) => state.details.requests
);

export const useIsRequestPendingKey = (apiKeyId: number, requestKey: TApiKeyRequestKey): TApiRequestState | null => {
  const requestPendingKeys = useSelector(apiKeysRequestsSelector);
  return requestPendingKeys[apiKeyId]?.[requestKey] || null;
};

export const useIsRequestPending = (requestKey: TApplicationRequestKey): TApiRequestState | null => {
  const requestPendingKeys = useSelector(applicationRequestsSelector);
  return requestPendingKeys[requestKey] || null;
};
